import { useState } from 'react';
import type { Snapshot } from '../shared/protocol';
import './reveal-art.css';

type RevealImage = NonNullable<NonNullable<Snapshot['reveal']>['images']>[number];

export function RevealArt({ image }: { image: RevealImage }) {
  const [failed, setFailed] = useState(false);
  return <figure className="reveal-art">
    {failed ? <div className="reveal-art__missing" role="status">Picture unavailable. {image.alt}</div> : <img src={image.imageUrl} alt={image.alt} onError={() => setFailed(true)} />}
    <figcaption>{image.credit} <a href={image.sourceUrl} target="_blank" rel="noreferrer">Source</a></figcaption>
  </figure>;
}
